export default "__VITE_ASSET__VZN2ZPYi__"